import '../App.css';
import React from "react";
import ApiCtrl from "../svc/ApiCtrl";
import 'mapbox-gl/dist/mapbox-gl.css';
import Map, {Layer, Popup, Source} from 'react-map-gl';
import {
    Checkbox,
    Typography,
    Box,
    CircularProgress,
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails, IconButton, Card, CardMedia, CardActions, CardContent, CardHeader
} from "@mui/material";
import * as turf from "@turf/turf";
import PdfIcon from '@mui/icons-material/PictureAsPdf';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {Margin, usePDF} from "react-to-pdf";

// eslint-disable-next-line
import mapboxgl from '!mapbox-gl';
import {
    mainColor,
    mainWhite,
    titleTextColor,
    mainTextColor,
    font,
    fontWidthThin,
    fontWidthVeryStrong,
    fontSizeVeryStrong,
    fontLineHeightVeryStrong,
    typeOfLcf,
    legends,
    colorScale,
    cardsHelp,
    formatSurface,
    formatPerc,
    getDescription, getNomArrondissement, getHeaderSynthese, noData, newColorScale
} from "./constant";
import schemaImg from "../cerema.png";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';


export default function PageIris() {
    const queryParameters = new URLSearchParams(window.location.search);

    const codeIris = queryParameters.get("iris") ? queryParameters.get("iris") : "371500000";

    const [item0, setItem0] = React.useState(false);

    const [nomCommune, setNomCommune] = React.useState(null);
    const options = {
        page: {
            // margin is in MM, default is Margin.NONE = 0
            margin: Margin.SMALL,
            // default is 'A4'
            format: 'letter',
            // default is 'portrait'
            orientation: 'landscape',
        },
        canvas: {
            // default is 'image/jpeg' for better size performance
            mimeType: 'image/png',
            qualityRatio: 1
        },
        // Customize any value passed to the jsPDF instance and html2canvas
        // function. You probably will not need this and things can break,
        // so use with caution.
        overrides: {
            // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
            pdf: {
                compress: true
            },
            // see https://html2canvas.hertzen.com/configuration for more options
            canvas: {
                useCORS: true
            }
        },
        //filename: `${view.name}-${new Date().getFullYear()}`
    };

    const {toPDF, targetRef} = usePDF(options);

    const [loading, setLoading] = React.useState(true);

    const [popupVisible, setPopupVisible] = React.useState(false);
    const [hoverInfo, setHoverInfo] = React.useState({});
    const [coords, setCoords] = React.useState(null);

    const [countArea, setCountArea] = React.useState(null);
    const [selectedLcf, setSelectedLcf] = React.useState(["1", "2", "3", "4", "5", "6", "8", "9", "A", "B", "C", "D", "E", "F", "G"]);
    const [bbox, setBBbox] = React.useState(null);
    const [allData, setAllData] = React.useState(null);

    const [centroid, setCentroid] = React.useState(null);


    const [surface, setSurface] = React.useState(null);
    const [localSurface, setLocalSurface] = React.useState(null);
    const [subItem0, setSubItem0] = React.useState(false);

    const [mapData, setMapData] = React.useState(null);

    const [buttonVisiblity, setButtonVisiblity] = React.useState(true);

    const [visible, setVisible] = React.useState({
        0: false,
        1: false,
        2: false,
        3: false,
        4: false
    });

    const [isAnArrondissement, setIsAnArrondissement] = React.useState(false);
    const [nomArrondissement, setNomArrondissement] = React.useState("");
    const [nomQuartiers, setNomQuariters] = React.useState([]);


    const [shape, setShape] = React.useState(null);
    React.useEffect(() => {
        ApiCtrl.getIrisShape(codeIris, (data) => {
            setShape(data);
        });

        ApiCtrl.getIrisData(codeIris, (data) => {
            if (data.length > 0) {
                let bboxShape = {
                    "type": "FeatureCollection",
                    "features": []
                };
                let tmpCount = {};

                let tmp = {};

                let surface = 0;
                let tmpSurface = {};
                let nomCommune = data[0].irisName
                    .replaceAll("[", "")
                    .replaceAll("]", "")
                    .replaceAll("'", "");

                let nomArrondissement = getNomArrondissement(data[0].irisCode);

                if (nomArrondissement !== "") {
                    setIsAnArrondissement(true);
                    setNomArrondissement(nomArrondissement)
                }
                let nomQuartiers = []
                data.forEach((d, k) => {
                    if (!tmp[d.lcz]) {
                        tmp[d.lcz] = {
                            "type": "FeatureCollection",
                            "features": []
                        }
                    }
                    if (!tmpCount[d.lcz]) {
                        tmpCount[d.lcz] = 0;
                    }

                    let geo = JSON.parse(d.feature);
                    tmp[d.lcz].features.push(geo)
                    bboxShape.features.push(geo);
                    tmpCount[d.lcz] += 1;

                    let localsurf = turf.area(geo);
                    surface += localsurf;
                    if (!tmpSurface[d.lcz]) {
                        tmpSurface[d.lcz] = 0;
                    }
                    tmpSurface[d.lcz] += localsurf;


                    let nomQuartier = d.irisName
                        .replaceAll("[", "")
                        .replaceAll("]", "")
                        .replaceAll("'", "");

                    if (nomQuartiers.indexOf(nomQuartier) === -1) {
                        nomQuartiers.push(nomQuartier)
                    }

                })
                let bbox = turf.bbox(bboxShape);
                let centroid = turf.centroid(bboxShape);
                setAllData(bboxShape);
                setCentroid(centroid.geometry.coordinates);
                setBBbox([[bbox[0] - 0.001, bbox[1] - 0.001], [bbox[2] + 0.001, bbox[3] + 0.001]]);
                setMapData(tmp);
                setCountArea(tmpCount);

                setSurface(surface);
                setLocalSurface(tmpSurface);
                setNomCommune(nomCommune)
                setNomQuariters(nomQuartiers);
            } else {
                setAllData([]);
                setCentroid({});
                setBBbox({});
                setMapData({});
                setCountArea({});

                setSurface({});
                setLocalSurface({});
                setNomCommune({})
                setNomQuariters({});
                setShape({})

            }
        })
    }, [codeIris])

    React.useEffect(() => {
        if (mapData && bbox && centroid && allData && countArea && nomCommune && shape) {
            setLoading(false);
        }
        console.log(mapData && bbox && centroid && allData && countArea && nomCommune && shape)
    }, [mapData, bbox, centroid, allData, countArea, nomCommune, shape])


    if (loading) {
        return (
            <Box sx={{width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Box sx={{
                    width: "80vw",
                    height: "80vh",
                    m: 5,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress/>
                </Box>
            </Box>)
    }

    function get3FirstElements() {
        let tmp = [];
        Object.keys(localSurface).forEach((key) => {
            tmp.push(key);
        })
        tmp.sort((a, b) => {
            return localSurface[b] - localSurface[a];
        })
        tmp = tmp.splice(0, 3);
        return tmp;
    }

    function changeStat0() {
        setItem0(!item0);
    }

    function generatePopup() {
        return (<Popup
            anchor="top"
            closeOnClick={false}
            onClose={() => {
                setHoverInfo({});
                setCoords(null);
                setPopupVisible(false);
            }}
            longitude={coords[0]}
            latitude={coords[1]}
            maxWidth={350}

        >
            <Box sx={{display: "flex", flexDirection: "column", width: 350}}>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography
                        sx={{
                            width: 200,
                            textOverflow: "ellipsis"
                        }}>typologie</Typography>
                    <Typography
                        sx={{width: 150}}>{typeOfLcf[hoverInfo.lcz]} ({hoverInfo.lcz})</Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography
                        sx={{
                            width: 200,
                            textOverflow: "ellipsis"
                        }}>Identifiant</Typography>
                    <Typography
                        sx={{width: 150}}>{hoverInfo.identifier}</Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography sx={{width: 200, textOverflow: "ellipsis"}}>Hauteur moyenne des bâtiments
                        (m)</Typography>
                    <Typography sx={{width: 150}}>{hoverInfo.hre}</Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography sx={{width: 200, textOverflow: "ellipsis"}}>Surface moyenne des bâtiments
                        (m²)</Typography>
                    <Typography sx={{width: 150}}>{hoverInfo.are}</Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography sx={{width: 200, textOverflow: "ellipsis"}}>Taux de surface bâtie (%)</Typography>
                    <Typography sx={{width: 150}}>{hoverInfo.bur}</Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography sx={{width: 200, textOverflow: "ellipsis"}}>Taux de surface imperméable (%)</Typography>
                    <Typography sx={{width: 150}}>{hoverInfo.ror}</Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography sx={{width: 200, textOverflow: "ellipsis"}}>Taux de sol nu perméable (%) </Typography>
                    <Typography sx={{width: 150}}>{hoverInfo.bsr}</Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography sx={{width: 200, textOverflow: "ellipsis"}}>Taux de surface en eau (%)</Typography>
                    <Typography sx={{width: 150}}>{hoverInfo.war}</Typography>
                </Box>

                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography sx={{width: 200, textOverflow: "ellipsis"}}>Taux de végétation (%)</Typography>
                    <Typography sx={{width: 150}}>{hoverInfo.ver}</Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row"}}>
                    <Typography sx={{width: 200, textOverflow: "ellipsis"}}>Part de végétation arborée (%)</Typography>
                    <Typography sx={{width: 150}}>{hoverInfo.vhr}</Typography>
                </Box>


            </Box>
        </Popup>)
    }

    if (allData.length === 0) {
        return noData();
    }

    return (
        <Box sx={{width: "95%", height: "80%", m: 5, display: "flex", flexDirection: "column"}}>
            <Box sx={{
                display: "flex",
                padding: "3px",
                position: "fixed",
                right: 5,
                zIndex: 99,
                top: 5,
            }}>
                <Button sx={{
                    textAlign: "center",
                    background: "rgb(255,137,137)",
                    color: "white",
                    display: buttonVisiblity ? "flex" : "none",
                    "&:hover": {
                        backgroundColor: "rgb(241,56,56)"
                    },
                }}
                        onClick={() => {
                            toPDF();
                        }}>

                    <Typography sx={{display: "flex"}}>
                        <PdfIcon/>
                        Export
                    </Typography>
                </Button>
            </Box>
            <Accordion sx={{
                '&:before': {
                    display: 'none',
                },
                boxShadow: "none",
                borderColor: "rgba(0, 0, 0, 0.125)",
                borderStyle: "solid",
                borderWidth: 1,
                borderRadius: "20px"
            }} expanded={item0}>
                <AccordionSummary onClick={changeStat0}
                                  expandIcon={
                                      <IconButton
                                          sx={[{
                                              backgroundColor: mainColor,
                                              "&:hover": {
                                                  backgroundColor: mainColor
                                              },
                                              color: mainWhite
                                          }, {display: buttonVisiblity ? "flex" : "none"}]}>
                                          <ExpandMoreIcon/>
                                      </IconButton>
                                  }
                                  sx={{
                                      backgroundColor: mainWhite,
                                      color: titleTextColor,
                                      borderRadius: "20px"
                                  }}>
                    < Typography
                        component={'span'}
                        sx={{
                            color: titleTextColor,
                            fontFamily: font,
                            fontSize: fontSizeVeryStrong,
                            lineHeight: fontLineHeightVeryStrong,
                            fontWeight: fontWidthVeryStrong
                        }}>
                        Ilots de Chaleurs Urbains & Zones Climatiques Locales
                    < /Typography>
                </AccordionSummary>
                <AccordionDetails ref={targetRef}>
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column"
                        }}

                    >
                        <Accordion sx={{
                            '&:before': {
                                display: 'none',
                            },
                            boxShadow: "none",
                            borderColor: "rgba(0, 0, 0, 0.125)",
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderRadius: "20px",
                            width: "100%"
                        }} expanded={subItem0}>
                            <AccordionSummary onClick={() => {
                                setSubItem0(!subItem0);
                            }}
                                              expandIcon={
                                                  <IconButton
                                                      sx={[{
                                                          backgroundColor: mainColor,
                                                          "&:hover": {
                                                              backgroundColor: mainColor
                                                          },
                                                          color: mainWhite
                                                      }]}>
                                                      <ExpandMoreIcon/>
                                                  </IconButton>
                                              }
                                              sx={{
                                                  backgroundColor: mainWhite,
                                                  color: titleTextColor,
                                                  borderRadius: "20px"
                                              }}>
                                < Typography
                                    component={'span'}
                                    sx={{
                                        color: titleTextColor,
                                        fontFamily: font,
                                        fontSize: fontSizeVeryStrong,
                                        lineHeight: fontLineHeightVeryStrong,
                                        fontWeight: fontWidthVeryStrong
                                    }}>
                                    Définitions et enjeux
                                < /Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box sx={{
                                    width: "100%",
                                    m: 1,
                                    display: "flex",
                                    flexDirection: "column"
                                }}>
                                    <Typography component={'span'} sx={{}}
                                                dangerouslySetInnerHTML={{
                                                    __html: getDescription()
                                                }}
                                    />
                                    <img src={schemaImg} width={800}/>
                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Box sx={{
                            width: "100%",
                            m: 1,
                            mt: 4,
                            display: "flex",
                            flexDirection: "column"
                        }}>
                            <Typography variant="h5" sx={{mb: 2}}>Synthèse territoire :</Typography>

                            <Typography variant="h6">
                                {getHeaderSynthese(false, isAnArrondissement, nomArrondissement, nomCommune, nomQuartiers)}
                            </Typography>
                        </Box>
                        <Box sx={{width: "100%", display: "flex", flexDirection: "column"}}>
                            <Typography variant="h6">
                                Ce territoire est composé de :
                            </Typography>
                            <ul>
                                {get3FirstElements().map((type, key) => {
                                    return (<li key={key} style={{margin: 10}}>
                                        <Box sx={{width: "100%", display: "flex"}}>
                                            <Box sx={{
                                                width: 20,
                                                height: 20,
                                                backgroundColor: newColorScale[type],
                                                mr: 2
                                            }}/>
                                            {typeOfLcf[type]} / {legends[type]}
                                        </Box>
                                        <ul>
                                            <li>Superficie occupée : {formatSurface(localSurface[type])}</li>
                                            <li>Part d’occupation de l’espace
                                                : {formatPerc(localSurface[type], surface)}</li>
                                        </ul>
                                    </li>)
                                })}
                            </ul>
                        </Box>

                        <Box sx={{width: "100%", m: 1, mt: 2, display: "flex"}}>
                            <Typography variant="h5">Zones locales climatiques et sensibilité aux phénomènes d’Ilots de
                                Chaleurs Urbains</Typography>
                        </Box>
                        <Box sx={{width: "100%", m: 1, display: "flex"}}>
                            <Box sx={{width: 500, height: "100%"}}>
                                {Object.keys(typeOfLcf).map((type, key) => {
                                    return (<Box sx={{width: 350, display: "flex", flexDirection: "column"}}
                                                 key={key}>
                                        <Box sx={{width: "100%", display: "flex", alignItems: "center"}}>
                                            <Box sx={{
                                                width: 20,
                                                height: 20,
                                                backgroundColor: colorScale[key][1]
                                            }}/>
                                            <Checkbox
                                                disabled={countArea[type] === undefined}
                                                checked={selectedLcf.includes(type)}
                                                onClick={
                                                    () => {
                                                        if (selectedLcf.includes(type)) {
                                                            setSelectedLcf(selectedLcf.filter((lcf) => lcf !== type));
                                                        } else {
                                                            setSelectedLcf([...selectedLcf, type]);
                                                        }
                                                    }
                                                }/>
                                            <Typography variant="body1"
                                                        color={(countArea[type] === undefined) ? "#c0c0c0" : "#000000"}>{typeOfLcf[type]}</Typography>
                                        </Box>
                                        <Box sx={{width: "100%", display: "flex", alignItems: "center"}}>
                                            <Typography variant="body2"
                                                        color={(countArea[type] === undefined) ? "#c0c0c0" : "#000000"}>{legends[type]}</Typography>
                                        </Box>
                                    </Box>)
                                })}
                            </Box>
                            <Box sx={{width: "100%"}}>
                                <Map
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                    initialViewState={{
                                        longitude: centroid[0],
                                        latitude: centroid[1],
                                        bounds: bbox

                                    }}
                                    mapStyle="mapbox://styles/mapbox/streets-v9"
                                    mapboxAccessToken={MAPBOX_TOKEN}
                                    interactive={true}
                                    preserveDrawingBuffer={true}
                                    attributionControl={false}
                                    onClick={() => {
                                        if (!popupVisible) {
                                            setPopupVisible(true)
                                        }
                                    }}
                                    onMouseMove={(event) => {
                                        if (!popupVisible) {
                                            let filter = allData.features.filter((county) => {
                                                return turf.booleanPointInPolygon(turf.point([event.lngLat.lng, event.lngLat.lat]), county);
                                            });

                                            if (filter && filter.length > 0) {
                                                let centroid = turf.centroid(filter[0]);
                                                setCoords(centroid.geometry.coordinates);
                                                setHoverInfo(filter[0].properties);
                                            } else {
                                                setCoords(null);
                                                setHoverInfo(null);
                                            }
                                        }

                                    }}

                                >

                                    {Object.keys(typeOfLcf).map((type, key) => {
                                        if (selectedLcf.includes(type) && mapData[type]) {
                                            return (<Source
                                                    key={key}
                                                    type="geojson"
                                                    data={mapData[type]}>
                                                    <Layer
                                                        type={'fill'}
                                                        paint={{
                                                            'fill-color': {
                                                                property: 'lcz_int',
                                                                stops: colorScale
                                                            },
                                                            'fill-opacity': {
                                                                property: 'lcz_int',
                                                                stops: [
                                                                    [-1, 0.5],
                                                                    [0, 0.5]
                                                                ]
                                                            },
                                                        }}
                                                    />
                                                </Source>

                                            )
                                        }
                                    })}
                                    {Object.keys(shape).map((id, key) => {
                                        const shp = JSON.parse(shape[id]);
                                        return (<Source
                                            type="geojson"
                                            data={shp}>
                                            <Layer
                                                type={'line'}
                                                paint={{
                                                    'line-width': 2,
                                                    'line-color': '#0080ef'
                                                }}
                                            />
                                        </Source>)
                                    })}
                                    {popupVisible && hoverInfo && coords && generatePopup()}
                                </Map>
                            </Box>
                        </Box>
                        <Box sx={{width: "100%", m: 1, mt: 2, display: "flex"}}>
                            <Typography variant="h6">Source : Ministère de la transition écologique de l'énergie, du
                                climat et de la prévention des risques / Cerema
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{width: "100%", m: 1, mt: 2, display: "flex"}}>
                        <Typography variant="h5">Moyens de lutte contre le phénomène d’ilots de chaleur
                            urbain </Typography>
                    </Box>
                    <Box sx={{width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "center"}}>
                        {cardsHelp && Object.keys(cardsHelp).map((key, index) => {
                            return <Card
                                key={key}
                                sx={{width: 400, m: 1}}>

                                <CardHeader
                                    title={key}
                                />
                                {visible[index] && <CardContent>
                                    <Typography gutterBottom variant="body2" component="div" dangerouslySetInnerHTML={{
                                        __html: cardsHelp[key]
                                    }}>
                                    </Typography>
                                </CardContent>}
                                <CardActions>
                                    {!visible[index] && <Button size="small" onClick={() => {
                                        let vis = visible
                                        vis[index] = true;
                                        setVisible({...vis})

                                    }}>plus de détails</Button>}
                                    {visible[index] && <Button size="small" onClick={() => {
                                        let vis = visible
                                        vis[index] = false;
                                        setVisible({...vis})

                                    }}>moins de détails</Button>}
                                </CardActions>
                            </Card>

                        })}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Box>
    )
}

